import axios from "axios";
import moment from "moment";
import { useEffect, useState } from "react";
import { IoAdd as AddIcon } from "react-icons/io5";
import { NotificationManager } from "react-notifications";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import badge from "../../assets/icons/badge.svg";
import building from "../../assets/icons/Building.svg";
import calendar from "../../assets/icons/calendar.svg";
import clock from "../../assets/icons/clock.svg";
import dollar from "../../assets/icons/dollar 2.svg";
import home from "../../assets/icons/Group 574.svg";
import house from "../../assets/icons/House.svg";
import key from "../../assets/icons/key-variant.svg";
import percentage from "../../assets/icons/percentage 2.svg";
import Circle from "../../assets/svgs/Ellipse 6.svg";
import LeftIcon from "../../assets/svgs/leftArrowIcon.svg";
import Edit from "../../assets/svgs/Pencil 2.svg";
import polygon from "../../assets/svgs/Polygon-grey.svg";
import DeleteIcon from "../../assets/svgs/Recycle Bin.svg";
import RightIcon from "../../assets/svgs/rightArrowIcon.svg";
import DeleteConfirmationModal from "../../components/ConfirmationModals/DeleteConfirmationModal";
import Loader from "../../components/Loader";
import SearchDropdownList from "../../components/SearchDropdownList";
import useAuth from "../../hooks/useAuth";
import BaseLayout from "../../layouts/BaseLayout";
import { BASE_URL } from "../../utils/Element";
import PropertyDetailHeader from "./components/PropertyDetailHeader";
import AddBovHistoryModal from "./Propertymodal/AddBovHistoryModal";
import AddPropertyHistoryModal from "./Propertymodal/AddPropertyHistoryModal";
import EditBovHistoryModal from "./Propertymodal/EditBovHistoryModal";
import EditPropertyHistoryModal from "./Propertymodal/EditPropertyHistoryModal";

const PropertyDetails = () => {
  const [config] = useAuth();
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showBovModal, setShowBovModal] = useState(false);
  const [editactmodal, setEditactmodal] = useState(false);
  const [editactbovmodal, setEditactbovmodal] = useState(false);
  const [disableDelete, setDisableDelete] = useState(false);
  const [propertyDetails, setPropertyDetails] = useState({});
  const [propertyhistory, setPropertyhistory] = useState([]);
  const [Bovhistory, setBovhistory] = useState([]);
  const [BovHistoryProperty, setBovHistoryProperty] = useState([]);
  const [deleteactmodal, setDeleteactmodal] = useState(false);
  const [deleteactbovmodal, setDeleteactbovmodal] = useState(false);
  const [selectedPropertyHistory, setSelectedPropertyHistory] = useState(null);
  const [selectedBovPropertyHistory, setSelectedBovPropertyHistory] = useState(null);

  const lease_term_remaining = propertyDetails?.lease_expiration_date
    ? moment(propertyDetails?.lease_expiration_date).diff(moment(), "years", true)
    : NaN;

  const propertyData = [
    { icon: home, amount: propertyDetails?.building_size ?? "", title: "Building Size" },
    { icon: house, amount: propertyDetails?.land_size ?? "", title: "Land Size" },
    { icon: building, amount: propertyDetails?.lease_type ?? "", title: "Lease Type" },
    { icon: house, amount: propertyDetails?.year_built ?? "", title: "Year Built" },
    { icon: house, amount: propertyDetails?.year_renovated ?? "", title: "Year Renovated " },
  ];

  const lastPriceHistory =
    propertyDetails?.property_price_history?.length > 0
      ? propertyDetails.property_price_history[propertyDetails.property_price_history.length - 1]
      : null;


  const formatDate = (dateString) =>
    dateString
      ? new Date(dateString).toLocaleDateString("en-US", {
        timeZone: "America/New_York",
      })
      : "";

  const leaseData = [
    {
      icon: badge,
      date: propertyDetails?.lease_commencement_date
        ? moment(propertyDetails.lease_commencement_date).format("MM/DD/YYYY")
        : "",
      title: "Lease Commencement Date",
    },
    {
      icon: key,
      date: propertyDetails?.lease_expiration_date
        ? moment(propertyDetails.lease_expiration_date).format("MM/DD/YYYY")
        : "",
      title: "Lease Expiration Date",
    },
    {
      icon: clock,
      date: Number.isNaN(lease_term_remaining)
        ? ""
        : lease_term_remaining > 1
          ? `${lease_term_remaining?.toFixed(2)} Years`
          : `${lease_term_remaining?.toFixed(2)} Year`,
      title: "Lease Term Remaining",
    },
    {
      icon: calendar,
      title: "Annual Rent / NOI",
      date: propertyDetails?.noi_format
        ? `$${propertyDetails.noi_format}`
        : propertyDetails?.anual_rent
          ? `$${Number(propertyDetails.anual_rent).toLocaleString()}`
          : "",
      valuedate: lastPriceHistory?.noi_format
        ? `$${lastPriceHistory.noi_format}`
        : "",
      subDate: lastPriceHistory?.updated_at
        ? formatDate(lastPriceHistory.updated_at)
        : "",
    },
    {
      icon: percentage,
      title: "Asking Cap Rate",
      date: propertyDetails?.asking_cap_rate_format
        ? `${propertyDetails.asking_cap_rate_format}%`
        : propertyDetails?.asking_cap_rate
          ? `${propertyDetails.asking_cap_rate}%`
          : "",
      valuedate: lastPriceHistory?.asking_cap_rate_format
        ? `${lastPriceHistory.asking_cap_rate_format}%`
        : "",
      subDate: lastPriceHistory?.updated_at
        ? formatDate(lastPriceHistory.updated_at)
        : "",
    },
    {
      icon: dollar,
      title: "Asking Price",
      date: propertyDetails?.asking_price_format
        ? `$${propertyDetails.asking_price_format}`
        : propertyDetails?.asking_price
          ? `$${Number(propertyDetails.asking_price).toLocaleString()}`
          : "",
      valuedate: lastPriceHistory?.asking_price_format
        ? `$${lastPriceHistory.asking_price_format}`
        : "",
      subDate: lastPriceHistory?.updated_at
        ? formatDate(lastPriceHistory.updated_at)
        : "",
    },
    {
      icon: key,
      date: propertyDetails?.guarantor_options
        ? propertyDetails.guarantor_options
        : "",
      title: "Guarantor Options",
    },
  ];





  const fetchPropertyDetails = () => {
    setLoading(true);
    const savedQueryParams = localStorage.getItem("queryParams");
    let localQueryParams = {};

    if (savedQueryParams) {
      localQueryParams = Object.fromEntries(new URLSearchParams(savedQueryParams));
    }
    axios
      .post(`${BASE_URL}/property-getbyid/${id}`, localQueryParams, config)
      .then((res) => {
        setPropertyDetails(res?.data?.data);
        setLoading(false);
      })
      .catch((err) => {
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      });
  };

  const fetchPropertyHistory = () => {
    axios
      .get(`${BASE_URL}/property-history-list?page=1&per_page=10&property_id=${id}`, config)
      .then((res) => {
        setPropertyhistory(res?.data?.data?.propertyhistories?.data || []);
      })
      .catch((err) => {
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      });
  };

  const fetchBovPropertyHistory = () => {
    axios
      .get(`${BASE_URL}/bovproperty-history-list?page=1&per_page=10&property_id=${id}`, config)
      .then((res) => {
        setBovhistory(res?.data?.data?.propertyhistories?.data || []);
      })
      .catch((err) => {
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      });
  };

  const fetchBovProperty = () => {
    axios
      .get(`${BASE_URL}/bov-property/${id}`, config)
      .then((res) => {
        setBovHistoryProperty(res?.data?.data?.LeadsList || []);
      })
      .catch((err) => {
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      });
  };

  useEffect(() => {
    fetchPropertyHistory();
    fetchBovProperty();
    fetchPropertyDetails();
  }, [id]);

  useEffect(() => {
    fetchBovPropertyHistory();
  }, [id]);

  const handleDelete = (propertyHistoryData) => {
    setSelectedPropertyHistory(propertyHistoryData);
    setDeleteactmodal(true);
  };

  const handleBovDelete = (propertyBovHistoryData) => {
    setSelectedBovPropertyHistory(propertyBovHistoryData);
    setDeleteactbovmodal(true);
  };

  const handleEditPropertyHistory = (propertyHistoryData) => {
    setSelectedPropertyHistory(propertyHistoryData);
    setEditactmodal(true);
  };

  const handleEditBovPropertyHistory = (propertyBovHistoryData) => {
    setSelectedBovPropertyHistory(propertyBovHistoryData);
    setEditactbovmodal(true);
  };

  const onSuccess = () => {
    setLoading(true)
    fetchPropertyDetails();
  }

  const handleDeletePropertyHistory = () => {
    setDisableDelete(true);
    axios
      .delete(`${BASE_URL}/delete-propertyhistory/${selectedPropertyHistory?.id}`, config)
      .then((res) => {
        if (res.data.success) {
          fetchPropertyHistory()
          setSelectedPropertyHistory("")
          onSuccess()
          setDeleteactmodal(false);
          if (res?.data?.message) {
            NotificationManager.success(res?.data?.message);
          }
        }
      })
      .catch((error) => {
        if (error.response?.data?.message) {
          NotificationManager.error(error.response?.data?.message);
        }
      })
      .finally(() => setDisableDelete(false));
  };

  const handleDeleteBovPropertyHistory = () => {
    setDisableDelete(true);
    axios
      .delete(`${BASE_URL}/delete-bovpropertyhistory/${selectedBovPropertyHistory?.id}`, config)
      .then((res) => {
        if (res.data.success) {
          fetchBovPropertyHistory();
          setSelectedBovPropertyHistory("")
          onSuccess()
          setDeleteactbovmodal(false);
          if (res?.data?.message) {
            NotificationManager.success(res?.data?.message);
          }
        }
      })
      .catch((error) => {
        if (error.response?.data?.message) {
          NotificationManager.error(error.response?.data?.message);
        }
      })
      .finally(() => setDisableDelete(false));
  };

  const queryParams = new URLSearchParams(location.search);
  const searchValue = queryParams.get("search");

  return (
    <BaseLayout>
      <div className="flex justify-between items-center">
        <p role="button" className="green-H head-5 underline" onClick={() => navigate(`/properties?search=${searchValue || ""}`)}>
          Back to Properties
        </p>

        <div className="body-S dark-M flex items-center gap-5">
          {propertyDetails?.previous_id !== null && (
            <div role="button" onClick={() => navigate(`/property/${propertyDetails?.previous_id}`)} className="flex items-center gap-2">
              <img src={LeftIcon} alt="" />
              Previous Property
            </div>
          )}

          {propertyDetails?.next_id !== null && (
            <div role="button" onClick={() => navigate(`/property/${propertyDetails?.next_id}`)} className="flex items-center gap-2">
              Next Property
              <img src={RightIcon} alt="" />
            </div>
          )}
        </div>

        <SearchDropdownList from="property" />
      </div>

      {loading ? (
        <Loader />
      ) : (
        <div className="contact-details light-bg-L">
          <PropertyDetailHeader propertydata={propertyDetails} />
          <div className="md:flex gap-5 mt-6">
            <div className="w-full md:w-[70%]">

              {/* Lease Information Section */}
              <p className="dark-M body-L">LEASE INFORMATION</p>

              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-3 gap-3 mt-4">
                {leaseData.slice(3, 6).map((el, idx) => (
                  <div
                    key={idx}
                    className="lease-info-card light-bg-L text-center p-4 rounded-2xl"
                  >
                    <img src={el.icon} alt="" className="green-bg-H mx-auto" />
                    <p className="head-2 dark-H mt-4 font-semibold">{el.date}</p>
                    {propertyDetails?.property_price_history?.length > 0 && (
                      <div className="">

                        {propertyDetails.property_price_history.map((item, i) => {
                          let value = "";
                          if (el.title === "Asking Price") {
                            value = item.asking_price_format
                              ? `$${item.asking_price_format}`
                              : item.asking_price
                                ? `$${Number(item.asking_price).toLocaleString()}`
                                : "";
                          } else if (el.title === "Asking Cap Rate") {
                            value = item.asking_cap_rate_format
                              ? `${item.asking_cap_rate_format}%`
                              : item.asking_cap_rate
                                ? `${item.asking_cap_rate}%`
                                : "";
                          } else if (el.title === "Annual Rent / NOI") {
                            value = item.noi_format
                              ? `$${item.noi_format}`
                              : item.noi
                                ? `$${Number(item.noi).toLocaleString()}`
                                : "";
                          }

                          return (
                            value && (
                              <div key={i} className="text-sm text-gray-600 flex justify-between">
                                <span>{formatDate(item.updated_at)}</span>
                                <span className="font-semibold text-black dark:text-white">{value}</span>
                              </div>
                            )
                          );
                        })}
                      </div>
                    )}
                    <p className="body-N dark-M">{el.title}</p>
                  </div>
                ))}
              </div>



              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-6 mt-6">
                {leaseData.slice(0, 3).concat(leaseData.slice(6, 7)).map((el, idx) => (
                  <div key={idx} className="lease-info-card light-bg-L text-center p-4 rounded-2xl">
                    <img src={el.icon} alt="" className="green-bg-H mx-auto" />
                    <p className="head-2 dark-H mt-4">{el.date}</p>
                    <p className="body-N dark-M">{el.title}</p>
                  </div>
                ))}
              </div>

              {/* Property Information Section */}
              <p className="dark-M body-L mt-8">PROPERTY INFORMATION</p>
              <div className=" flex flex-wrap gap-6 mt-4">
                {propertyData.map((el, idx) => (
                  <div key={idx} className="lease-info-card light-bg-L">
                    <img src={el.icon} alt="" className="green-bg-H mx-auto" />
                    <p className="head-2 dark-H mt-4">{el.amount}</p>
                    <p className="body-N dark-M">{el.title}</p>
                  </div>
                ))}
              </div>
            </div>


            <div className="w-full md:w-[30%]">

              <div className="px-4 mt-8 md:mt-0 mb-8" style={{ borderLeft: "1px solid #EDF0EB" }}>
                <div className="flex justify-between">
                  <p className="dark-H head-3">Property History</p>
                  <p
                    role="button"
                    className="green-H head-5 flex items-center"
                    onClick={() => {
                      setShowModal(true);
                    }}
                  >
                    <AddIcon size={20} /> Add
                  </p>
                </div>

                <div className="property-history-info mt-6">
                  {propertyhistory.length === 0 ? (
                    <p className="text-center">No property history</p>
                  ) : (
                    propertyhistory.map((el, idx) => (
                      <div key={idx} className="pl-4 flex items-start mt-8 relative">
                        <img src={Circle} alt="icon" className="absolute top-3 -left-[6px]" />
                        <img src={polygon} alt="icon" className="mt-3" />
                        <div className="light-bg-H card-info flex justify-between items-start gap-2 w-[100%]">
                          <div>
                            <p className="body-N dark-M">{moment(el.sold_date).format("MM/DD/YYYY")}</p>
                            <p className="dark-M body-N">${el.sold_price?.toLocaleString()}</p>
                            <p className="dark-M body-N">{el.sold_cap_rate?.toLocaleString()}%</p>
                            <p className="dark-M body-N">Buyer:{el.buyer?.toLocaleString()}</p>
                            <p className="dark-M body-N">Seller:{el.seller?.toLocaleString()}</p>


                          </div>
                          <div className="flex gap-1">
                            <img role="button" src={DeleteIcon} alt="" className="sidebar-icons" onClick={() => handleDelete(el)} />
                            <img role="button" src={Edit} alt="" className="sidebar-icons" onClick={() => handleEditPropertyHistory(el)} />
                          </div>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>


              <div className="px-4 mt-8 md:mt-0" style={{ borderLeft: "1px solid #EDF0EB" }}>
                <div className="flex justify-between">
                  <p className="dark-H head-3">BOV History</p>
                  <p
                    role="button"
                    className="green-H head-5 flex items-center"
                    onClick={() => {
                      setShowBovModal(true);
                    }}
                  >
                    <AddIcon size={20} /> Add
                  </p>
                </div>

                <div className="property-history-info mt-6">
                  {Bovhistory.length === 0 ? (
                    <p className="text-center">No BOV history</p>
                  ) : (
                    Bovhistory.map((el, idx) => (
                      <div key={idx} className="pl-4 flex items-start mt-8 relative">
                        <img src={Circle} alt="icon" className="absolute top-3 -left-[6px]" />
                        <img src={polygon} alt="icon" className="mt-3" />
                        <div className="light-bg-H card-info flex justify-between items-center gap-2 w-[100%]">
                          <div>
                            <p className="dark-H head-4">${el.suggested_sale_price?.toLocaleString()}</p>
                            <p className="body-N dark-M">{moment(el.bov_date).format("MM/DD/YYYY")}</p>
                            <p className="dark-H head-4">{el.suggested_cap_rate?.toLocaleString()}%</p>
                          </div>
                          <div className="flex gap-1">
                            <img role="button" src={DeleteIcon} alt="" className="sidebar-icons" onClick={() => handleBovDelete(el)} />
                            <img role="button" src={Edit} alt="" className="sidebar-icons" onClick={() => handleEditBovPropertyHistory(el)} />
                          </div>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>

            </div>

          </div>


        </div>
      )}

      <AddPropertyHistoryModal
        showModal={showModal}
        onClose={() => setShowModal(false)}
        onPropertyHistoryAdded={fetchPropertyHistory}
      />

      <AddBovHistoryModal
        showBovModal={showBovModal}
        onClose={() => setShowBovModal(false)}
        onBovPropertyHistoryAdded={fetchBovPropertyHistory}
      />

      <EditPropertyHistoryModal
        showModal={editactmodal}
        onClose={() => setEditactmodal(false)}
        onPropertyHistoryAdded={fetchPropertyHistory}
        selectedPropertyHistory={selectedPropertyHistory}
      />

      <EditBovHistoryModal
        showBovModal={editactbovmodal}
        onClose={() => setEditactbovmodal(false)}
        onPropertyHistoryAdded={fetchBovPropertyHistory}
        selectedBovPropertyHistory={selectedBovPropertyHistory}
      />

      <DeleteConfirmationModal
        showModal={deleteactmodal}
        disable={disableDelete}
        onClose={() => setDeleteactmodal(false)}
        handleDelete={handleDeletePropertyHistory}
      />

      <DeleteConfirmationModal
        showModal={deleteactbovmodal}
        disable={disableDelete}
        onClose={() => setDeleteactbovmodal(false)}
        handleDelete={handleDeleteBovPropertyHistory}
      />
    </BaseLayout>
  );
};

export default PropertyDetails;
